import { useContext } from 'react';
import { ConfirmContext } from '~ComponentsImproved/ConfirmModal/ConfirmContextProvider';
export default () => {
  const [confirmState, setConfirmState] = useContext(ConfirmContext);

  const confirm = (
    prompt: string,
    buttonTexts?: { left: string; right: string },
    subtitle?: string,
  ) => {
    if (!confirmState || !setConfirmState) {
      return Promise.reject();
    }

    const promise = new Promise((resolve, reject) => {
      setConfirmState({
        prompt,
        subtitle,
        isOpen: true,
        onConfirm: resolve,
        onCancel: reject,
        buttonTexts,
      });
    });
    return promise.then(
      () => {
        setConfirmState({ ...confirmState, isOpen: false });
        return true;
      },
      () => {
        setConfirmState({ ...confirmState, isOpen: false });
        return false;
      },
    );
  };
  return {
    ...confirmState,
    confirm,
  };
};
